export const openOverlay = (isMobile) => {
  if (isMobile) {
    document.body.dataset.scrollTop = String(window.pageYOffset);

    document.body.style.cssText = `
    overflow-y: hidden;
    position: fixed;
  `;
  }
};

export const closeOverlay = (isMobile) => {
  if (isMobile) {
    document.body.style.cssText = `
    overflow-y: auto;
    position: unset;
  `;

    window.scrollTo(0, Number(document.body.dataset.scrollTop));
  }
};
